// In-memory dummy store for the HPS List (read-only; no create/update/delete —
// this screen only ever lists records owned by other stages of the pipeline).
// Mirrors procurementStore.js's shape so wiring a real API later is a drop-in.

import { SEED_HPS_REQUESTS } from './hpsDummyData';

const clone = obj => JSON.parse(JSON.stringify(obj));

let records = clone(SEED_HPS_REQUESTS);

// Keyword search — Title, Id Procurement and Description only (per DOD item 2).
const matchesSearch = (r, q) => {
  if (!q) return true;
  const needle = q.toLowerCase();
  return (
    (r.procId || '').toLowerCase().includes(needle) ||
    (r.title || '').toLowerCase().includes(needle) ||
    (r.description || '').toLowerCase().includes(needle)
  );
};

// Sortable fields — every column except Action (per DOD item 6).
const SORTABLE_FIELDS = [
  'procId',
  'hpsNo',
  'title',
  'procurementType',
  'procurementMethod',
  'description',
  'mainStatus',
  'hpsStatus',
];

const getSortValue = (r, field) =>
  SORTABLE_FIELDS.includes(field) ? r[field] || '' : '';

export const list = ({
  search = '',
  page = 1,
  pageSize = 10,
  sortField = null,
  sortDir = 'asc',
} = {}) => {
  let filtered = records.filter(r => matchesSearch(r, search));

  if (sortField) {
    filtered = [...filtered].sort((a, b) => {
      const cmp = String(getSortValue(a, sortField)).localeCompare(
        String(getSortValue(b, sortField)),
        undefined,
        { numeric: true, sensitivity: 'base' }
      );
      return sortDir === 'asc' ? cmp : -cmp;
    });
  }

  const totalCount = filtered.length;
  const start = (page - 1) * pageSize;
  return { items: clone(filtered.slice(start, start + pageSize)), totalCount };
};

// Unpaginated — feeds the per-HPS-Status summary cards.
export const listAll = ({ search = '' } = {}) =>
  clone(records.filter(r => matchesSearch(r, search)));

// Test/util hook — reset back to the seed set.
export const _reset = () => {
  records = clone(SEED_HPS_REQUESTS);
};
